import { Navigate } from "react-router-dom";
import { useOnboardingValidation } from "../../hooks/useOnboardingValidation";
import { useAuth } from "../../contexts/AuthContext";
import { useLocalePath } from "../../hooks/useLocalePath";
import { Icon } from "@iconify/react";

/**
 * Ensures user has completed required onboarding.
 * Redirects to appropriate onboarding step with locale prefix.
 */
const OnboardingGuard = ({ children, requireOnboarding = true }) => {
  const { loading } = useAuth();
  const { isComplete, redirectPath } = useOnboardingValidation();
  const lp = useLocalePath();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Icon icon="svg-spinners:eclipse" className="w-12 h-12 text-primary" />
      </div>
    );
  }

  if (!requireOnboarding) {
    return children;
  }

  if (!isComplete && redirectPath) {
    // redirectPath comes from useOnboardingValidation as absolute path like /auth/onboarding/business
    return <Navigate to={lp(redirectPath)} replace />;
  }

  return children;
};

export default OnboardingGuard;
